module.exports = __webpack_public_path__ + "img/ai_speaking_jpM.3e3a5320.png";